// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"333":"73045d56e0f0e24e","888":"15d4ef2711f92362"}[chunkId] + ".css";
};